/**
 * Русские тексты мини-аппа. Ключ — английская фраза: так строку видно в коде
 * без прыжка в словарь, а отсутствующий перевод деградирует в читаемый английский,
 * а не в `plans.filter.days`.
 *
 * Плюрализацию делает i18next по `Intl.PluralRules`: суффиксы `_one/_few/_many`
 * для русского, `_one/_other` для английского. Своих тернарников по числам не писать —
 * они врут на 2-4 и на 11-14.
 */
const ru: Record<string, string> = {
  "Report a problem": "Сообщить об ошибке",
  "Report code": "Код отчёта",
  "Sending…": "Отправляю…",
  "Send report to developers": "Отправить отчёт разработчикам",
  "Describe what happened (optional)": "Опишите, что случилось (необязательно)",
  "Thanks, developers will look into it": "Спасибо! Разработчики уже разбираются.",
  "Could not send, save the code": "Не удалось отправить. Сохраните код и назовите его в поддержке.",
  "Send the details to developers so they can fix it faster": "Отправьте детали разработчикам, чтобы починили быстрее.",
  "Close": "Закрыть",
  "Choose Plan": "Выбрать тариф",
  "Active Subscription": "Активная подписка",
  "No logs": "Строго без логов",
  "Works globally": "Работает в РФ и мире",
  "Easy payment": "Оплата картой и криптой",
  "Plans": "Тарифы",
  "Home": "Главная",
  "Activity": "Журнал",
  "Settings": "Настройки",
  "Profile": "Профиль",
  "Disabled title": "Бот временно недоступен",
  "Disabled description": "Возможно, владелец приостановил продажи или ваш аккаунт заблокирован. Если это ошибка, свяжитесь с поддержкой.",
  "Webapp off title": "Приложение выключено",
  "Webapp off description": "Владелец бота ведёт продажи в переписке. Вернитесь в чат: там можно выбрать тариф, оплатить и получить доступ.",
  "Webapp off close": "Вернуться в чат",
  "Tg offline title": "Telegram не отвечает",
  "Tg offline description": "Не удалось получить данные для входа. Обычно это обрыв связи или включённый VPN. Проверьте интернет и откройте приложение заново.",
  "Tg offline retry": "Обновить",
  "Tg no init data title": "Откройте из бота",
  "Tg no init data description": "Данные для входа передаёт Telegram. По прямой ссылке в браузере приложение не работает: откройте его кнопкой меню в боте.",
  "Disabled close": "Закрыть",
  "Days left": "Осталось дней",
  "Renew": "Продлить",
  "Change plan": "Сменить тариф",
  "Devices": "Устройства",
  "Auto-renew": "Авто-продление",
  "Auto-renew desc": "Продлевать автоматически за 24 ч до конца. Спишется с баланса.",
  "Gift Subscription": "Подарить подписку",
  "Copy referral link": "Скопировать ссылку",
  "Invite a Friend": "Пригласить друга",
  "Copy Link": "Скопировать ссылку",
  "Freeze Subscription": "Заморозить подписку",
  "Current Plan": "Текущий тариф",
  "Active": "Активна",
  "Traffic Used": "Использовано трафика",
  "Manage": "Управлять",
  "Connected": "Подключено",
  "Language saved on this device only": "Сохранили только на этом устройстве. Бот может остаться на прежнем языке.",
  "Giveaways": "Розыгрыши",
  "No giveaways yet": "Сейчас розыгрышей нет",
  "When a giveaway starts, it will appear here.": "Когда начнётся розыгрыш, он появится здесь.",
  "Prize": "Приз",
  "Take part": "Участвовать",
  "Check again": "Проверить ещё раз",
  "Drawing winners…": "Выбираем победителей…",
  "Drawing in progress — results will arrive in the bot.": "Идёт жеребьёвка, результат придёт в бот.",
  "You're in. We'll message you in the bot when it ends.": "Вы участвуете. Напишем в бот, когда розыгрыш закончится.",
  "You won! The prize is already on your account.": "Вы выиграли! Приз уже на вашем аккаунте.",
  "Subscribe to": "Подпишитесь на",
  "the channel": "канал",
  "Invite friends who buy a plan": "Пригласите друзей, которые купят подписку",
  "of": "из",
  "Could not check — try again in a minute.": "Не удалось проверить, попробуйте через минуту.",
  "Referral copy": "+5 ГБ и 15% от платежей друзей",
  "Order Summary": "Заказ",
  "Payment Method": "Способ оплаты",
  "Promo Code": "Промокод",
  "Apply": "Применить",
  "Promo placeholder": "DISCOUNT10",
  "Promo applied": "Промокод {{code}} активирован: {{discount}}",
  "Promo too short": "Слишком короткий",
  "Promo too long": "Слишком длинный",
  "Promo invalid": "Неверный промокод",
  "Promo discount toast": "Промокод применён! Скидка {{discount}}.",
  "Terms agreement": "Оплачивая, вы соглашаетесь с офертой.",
  "Terms agreement prefix": "Оплачивая, вы соглашаетесь с",
  "Terms agreement link": "пользовательским соглашением",
  "Processing Payment": "Обрабатываем платёж",
  "Processing hint": "Обычно занимает 5-15 секунд.",
  "Verifying payment": "Проверяем оплату",
  "Creating subscription": "Создаём подписку",
  "Preparing config": "Готовим конфиг",
  "Go to dashboard": "Перейти в кабинет",
  "Subscription Ready": "Подписка активна",
  "Subscription Ready desc": "VPN готов к использованию.",
  "Connect on": "Подключить на {{os}}",
  "Connect on this device": "Подключить на этом устройстве",
  "Connect another device": "Подключить другое устройство",
  "Connect other devices desc": "Скопируйте ссылку и вставьте её в свой VPN-клиент: INCY, Happ, V2RayTun или Streisand. На некоторых iPhone Happ некорректно показывает серверы обхода белых списков (в конце списка), для iPhone рекомендуем INCY.",
  "Copy": "Скопировать",
  "Copied": "Скопировано",
  "Language": "Язык",
  "Privacy Policy": "Политика конфиденциальности",
  "Support": "Поддержка",
  "Network status": "Статус сети",
  "Status operational": "Все системы работают",
  "Status degraded": "Частичные сбои",
  "Status down": "Серьёзный сбой",
  "Status no data": "Собираем данные",
  "Status vpn network": "VPN-сеть",
  "Status section network": "Сеть «{{section}}»",
  "Status locations": "Локаций",
  "Status uptime": "Аптайм",
  "Status countries": "Страны",
  "Status days ago": "{{count}} дней назад",
  "Status today": "сегодня",
  "Status checked": "Проверено {{time}}",
  "Status empty": "Список стран появится после ближайшей синхронизации.",
  "Status unavailable": "Статус временно недоступен. Попробуйте позже.",
  "Status label ok": "Работает",
  "Status label none": "Нет данных",
  "Status time now": "только что",
  "Status time min": "{{count}} мин назад",
  "Status time hour": "{{count}} ч назад",
  "Status time day": "{{count}} дн назад",
  "No devices": "Нет устройств",
  "No devices desc": "Вы ещё не подключали устройства.",
  "No activity": "Пока ничего",
  "No activity desc": "Нет подключений под этот фильтр.",
  "Reviews": "Отзывы",
  "Reviews latest": "Последние отзывы",
  "Reviews recommends": "Рекомендует",
  "Shop reply": "Ответ магазина",
  "Reviews complains": "Есть претензии",
  "Reviews verified note": "Только подтверждённые подписки",
  "Reviews empty": "Пока нет отзывов",
  "Reviews empty desc": "Оставьте первый, он появится здесь сразу.",
  "Reviews leave": "Оставить отзыв",
  "Review tile hint": "Его увидят другие клиенты бота",
  "Reviews edit": "Изменить отзыв",
  "Review reward given": "Скидка {{percent}}% на следующую покупку уже ждёт вас.",
  "Review hidden": "Отзыв скрыт",
  "Review hidden desc": "Ваш отзыв не показывается на витрине, изменить его нельзя.",
  "Review sub hidden": "отзыв скрыт",
  "Reviews form title": "Как вам сервис?",
  "Reviews form hint": "Оценка обязательна, текст по желанию.",
  "Reviews thanks": "Спасибо, отзыв опубликован",
  "Disclose free": "Указать, что подписка получена бесплатно",
  "Disclose promo": "Указать, что подписка активирована промокодом",
  "Review badge free": "Получено бесплатно",
  "Review badge promo": "По промокоду",
  "Filter all": "Все",
  "Filter success": "Успех",
  "Filter failed": "Ошибки",
  "Upgrade Plan": "Сменить тариф",
  "Order plan": "{{devices}} устройств",
  "Auto-renew on": "Авто-продление включено",
  "Auto-renew off": "Авто-продление выключено",
  "Pay via": "Оплатить {{price}}\u00a0₽ через {{provider}}",
  "Pay via auto": "Оплатить {{price}}\u00a0₽ через {{provider}} · автопродление",
  "Checkout total via": "К оплате {{price}}\u00a0₽ через {{provider}}",
  "Checkout total via auto": "К оплате {{price}}\u00a0₽ через {{provider}}, дальше {{period}} автоматически",
  "Checkout total balance": "Спишем {{price}}\u00a0₽ с баланса",
  "Upgrade to": "Сменить на {{plan}}",
  "Tg user fallback": "Пользователь Telegram",
  "Profile section account": "Аккаунт",
  "Profile section program": "Программа",
  "Profile section help": "Помощь и настройки",
  "Profile balance": "Баланс кошелька",
  "Profile referrals": "Реферальная программа",
  "Profile referrals invited": "приглашено",
  "Profile gift": "Подарить подписку",
  "Profile devices": "Мои устройства",
  "Profile subscription": "Моя подписка",
  "Profile freeze": "Заморозить подписку",
  "Profile logout": "Сбросить локальный кэш",
  "Profile version": "Версия приложения",
  "Referral link copied": "Реферальная ссылка скопирована",
  "Giveaway invite link copied": "Ссылка скопирована",
  "Plans filter days": "Дни",
  "Plans filter devices": "Устройства",
  "Plans filter traffic": "Трафик",
  "Plans filter all": "Все",
  "Plans empty": "Нет тарифов под текущие фильтры",
  "Local cache cleared": "Локальный кэш сброшен",
  "Clipboard unavailable": "Не удалось скопировать. Зажмите ссылку, чтобы выделить.",
  "Crash title": "Что-то сломалось",
  "Unknown error": "Неизвестная ошибка",
  "Reload page": "Перезагрузить",
  "Cancel": "Отмена",
  "Badge active": "Активна",
  "Badge frozen": "Заморожена",
  "Badge expired": "Истекла",
  "Pay with": "Оплата через",
  "Provider platega": "СБП",
  "Provider aurapay": "СБП 2",
  "Provider aurapay_card": "Карта РФ",
  "Provider antilopay": "СБП",
  "Provider stars": "Звёзды",
  "Count ratings_one": "{{count}} оценка",
  "Count ratings_few": "{{count}} оценки",
  "Count ratings_many": "{{count}} оценок",
  "Count ratings_other": "{{count}} оценок",
  "Reviews positive": "Положительных",
  "Reviews complaints": "С претензиями",
  "Verified subscription": "Подтверждённая подписка",
  "Months with us_one": "{{count}} месяц с нами",
  "Months with us_few": "{{count}} месяца с нами",
  "Months with us_many": "{{count}} месяцев с нами",
  "Months with us_other": "{{count}} месяцев с нами",
  "Review renewed": "продлена",
  "Review until": "до {{date}}",
  "Review send failed": "Не удалось отправить отзыв",
  "Review subject": "О какой подписке отзыв",
  "Review sub ended": "завершена",
  "Review sub reviewed": "отзыв есть",
  "Rating aria": "Оценка {{n}}",
  "Rating of five aria": "Оценка {{n}} из 5",
  "Review placeholder": "Что понравилось или что стоит починить",
  "Count days_one": "{{count}} день",
  "Count days_few": "{{count}} дня",
  "Count days_many": "{{count}} дней",
  "Count days_other": "{{count}} дней",
  "Count weeks_one": "{{count}} неделя",
  "Count weeks_few": "{{count}} недели",
  "Count weeks_many": "{{count}} недель",
  "Count weeks_other": "{{count}} недель",
  "Count months_one": "{{count}} месяц",
  "Count months_few": "{{count}} месяца",
  "Count months_many": "{{count}} месяцев",
  "Count months_other": "{{count}} месяцев",
  "Count years_one": "{{count}} год",
  "Count years_few": "{{count}} года",
  "Count years_many": "{{count}} лет",
  "Count years_other": "{{count}} лет",
  "Count devices_one": "{{count}} устройство",
  "Count devices_few": "{{count}} устройства",
  "Count devices_many": "{{count}} устройств",
  "Count devices_other": "{{count}} устройств",
  "Count locations_one": "{{count}} локация",
  "Count locations_few": "{{count}} локации",
  "Count locations_many": "{{count}} локаций",
  "Count locations_other": "{{count}} локаций",
  "This device": "этом устройстве",
  "Confirm action": "Подтвердите действие",
  "Confirm": "Подтвердить",
  "Open from bot menu": "Откройте мини-апп через кнопку меню в боте.",
  "Connections": "Подключения",
  "Connections desc": "История подключений ваших устройств к VPN. Видите чужой IP: конфиг утёк, удалите устройство.",
  "Device hwid": "Устройство {{id}}",
  "Device unknown": "Неизвестное устройство",
  "Support not set up": "Поддержка не настроена для этого бота",
  "FAQ what is it": "Что это",
  "FAQ about fallback": "VPN-сервис для безопасного и быстрого доступа в интернет.",
  "FAQ whats inside": "Что внутри",
  "FAQ payment note": "Оплата: СБП, банковские карты, Telegram Stars и криптовалюта. Какие способы доступны, видно на экране оплаты. Возникли вопросы, напишите в поддержку из профиля.",
  "Documents": "Документы",
  "Terms of service": "Пользовательское соглашение",
  "Privacy policy": "Политика конфиденциальности",
  "Servers": "Серверы",
  "Locations auto pick": "Авто-выбор ближайшей. Любой клиент VPN сам подключится.",
  "Locations unavailable": "Список временно недоступен. Попробуйте позже.",
  "Connect to any": "Подключиться к любой",
  "Connect to any desc": "Выберите тариф, VPN активируется моментально",
  "Updated at": "Обновлено: {{time}}",
  "Reviews filter good": "Хорошие",
  "Reviews filter bad": "Плохие",
  "Reviews positive share": "{{percent}}% положительных",
  "Shown of total": "{{shown}} из {{total}}",
  "Loading": "Загружаем",
  "Show more": "Показать ещё",
  "Region Europe": "Европа",
  "Region North America": "Северная Америка",
  "Region South America": "Южная Америка",
  "Region Asia": "Азия",
  "Region Oceania": "Океания",
  "Region Africa": "Африка",
  "Region Other": "Прочее",
  "Locations word_one": "локация",
  "Locations word_few": "локации",
  "Locations word_many": "локаций",
  "Locations word_other": "локаций",
  "Intent subscribe": "Покупка подписки",
  "Intent renew": "Продление",
  "Intent upgrade": "Апгрейд",
  "Intent traffic": "Покупка трафика",
  "Intent addon": "Докупка к подписке",
  "Intent devices": "Покупка устройств",
  "Intent topup": "Пополнение баланса",
  "Intent unknown": "Пополнение",
  "Intent referral bonus": "Реферальный бонус",
  "Intent adjustment": "Корректировка баланса",
  "Intent refund": "Возврат",
  "Intent voucher": "Ваучер",
  "Intent giveaway prize": "Приз розыгрыша",
  "Intent gift": "Подарок другу",
  "Intent payment": "Оплата",
  "Intent credit": "Зачисление на баланс",
  "Intent debit": "Списание с баланса",
  "Payment status paid": "Оплачено",
  "Payment status pending": "Ждёт оплаты",
  "Payment status failed": "Не прошёл",
  "Payment status cancelled": "Отменён",
  "Payment status expired": "Счёт истёк",
  "Payment status refunded": "Возврат",
  "Source balance": "С баланса",
  "Payments history": "История платежей",
  "Payments load failed": "Не удалось загрузить историю.",
  "Retry": "Повторить",
  "Payments empty": "Пока нет платежей.",
  "Topup title": "Пополнить баланс",
  "Topup desc": "Деньги зачислятся на ваш баланс. Потратите их потом на продление, апгрейд или покупку трафика.",
  "Amount": "Сумма",
  "Custom amount": "Своя сумма (₽)",
  "Custom amount hint": "например 750",
  "Topup fee note": "К оплате {{total}} ₽: {{percent}}% берёт платёжная система. На баланс зачислим {{amount}} ₽, и покупки с него пойдут без надбавки.",
  "Invoice failed": "Не удалось создать счёт",
  "No providers": "Платёжные провайдеры не настроены.",
  "No providers support": "Платёжные провайдеры не настроены. Свяжитесь с поддержкой.",
  "Upgrade done": "Тариф обновлён",
  "Upgrade no balance": "Недостаточно средств на балансе. Пополните баланс и попробуйте снова.",
  "Upgrade plan gone": "План недоступен, выберите другой.",
  "Upgrade failed": "Не удалось перейти на тариф",
  "Upgrade confirm exact": "Перейти на {{plan}}? С баланса спишется {{amount}}.",
  "Upgrade confirm": "Перейти на {{plan}}? Доплата спишется с баланса.",
  "Upgrade confirm title": "Подтверждение перехода",
  "Upgrade current plan": "Текущий тариф",
  "Upgrade rule": "Доплата = цена нового тарифа минус неиспользованный остаток текущего. Списывается с баланса, срок нового тарифа отсчитывается заново. Сменить можно только на более ёмкий тариф в том же периоде.",
  "Upgrade surcharge": "доплата",
  "Upgrade none title": "На периоде «{{period}}» более ёмкого тарифа нет.",
  "Upgrade none desc": "Чтобы получить больше устройств или трафика, дождитесь окончания подписки и купите новую.",
  "Plan devices unlim": "{{devices}} · безлимит",
  "Plan devices unlim gb": "{{devices}} · безлимит · {{gb}} ГБ на обход",
  "Giveaway soon": "скоро итоги",
  "Giveaway left min": "осталось {{count}} мин",
  "Giveaway left hour": "осталось {{count}} ч",
  "Giveaway left day": "осталось {{count}} дн",
  "Giveaway no tasks": "Участвовать может любой, задания не нужны.",
  "Giveaway invite link": "Ваша ссылка для приглашений",
  "Giveaway open channel": "Открыть канал",
  "Share": "Поделиться",
  "Giveaway share text": "Подключись к моему VPN, мне зачтётся приглашение",
  "Giveaway tile new": "Новый розыгрыш, участвуйте",
  "Giveaway tile ready": "Можно участвовать",
  "Own VPN": "Свой VPN",
  "Open in browser": "Открыть в браузере",
  "Open in browser hint": "Работает и без Telegram",
  "Site link failed": "Не получилось открыть сайт. Попробуйте ещё раз.",
  "Site link too often": "Слишком часто. Подождите минуту и попробуйте снова.",
  "Own VPN hint": "Свой магазин с вашими ценами: заработок на VPN",
  "Giveaway tile joined": "Вы участвуете, ждём итогов",
  "Giveaway tile todo": "Выполните задания и участвуйте",
  "Trial freeze note": "Пробную подписку заморозить нельзя. Заморозка доступна на платных тарифах.",
  "Referral link missing": "Реф-ссылка пока недоступна",
  "Link copied": "Ссылка скопирована",
  "Referral share text": "Подключись к моему VPN, быстро и без логов",
  "Upgrade action": "Апгрейд",
  "Save failed": "Не сохранилось",
  "Sub unfrozen": "Подписка разморожена",
  "Sub frozen": "Подписка заморожена",
  "Refreshing status": "Не получилось, обновляю статус",
  "Frozen": "Заморожена",
  "Until date": "до {{date}}",
  "Trial period": "Пробный период",
  "Traffic bypass left": "Осталось на обход",
  "Traffic of total": "ГБ из {{total}}",
  "Traffic note trial": "На штатных локациях трафик безлимитный. Серверов обхода белых списков в пробном периоде нет, они на платных тарифах.",
  "Traffic note paid": "Лимит только на серверах обхода белых списков. На штатных локациях трафик безлимитный. Израсходовано за всё время подписки: {{used}} ГБ. При продлении лимит увеличивается, израсходованное не обнуляется.",
  "Connect VPN": "Подключить VPN",
  "Trial cannot renew": "Пробный период не продлевается: выберите тариф",
  "Freeze": "Заморозить",
  "Unfreeze": "Разморозить",
  "Buy GB": "Купить ГБ",
  "Gift": "Подарить",
  "Top up": "Пополнить",
  "Invite a friend": "Пригласите друга",
  "Referral explain l1": "Делитесь ссылкой, друг покупает подписку, вы получаете",
  "Referral explain l1 tail": "с его платежей на свой баланс.",
  "Referral explain l2": "А если друг тоже кого-то зовёт, вы получаете ещё",
  "Referral explain l2 tail": "со второго уровня.",
  "Already invited": "Уже приглашено:",
  "Freeze title": "Заморозить подписку?",
  "Unfreeze title": "Разморозить подписку?",
  "Unfreeze desc": "Подписка снова станет активной, дни продолжат списываться.",
  "Freeze desc": "Дни перестанут списываться. Разморозить можно в любой момент.",
  "Rotate failed": "Не удалось обновить ссылку, попробуйте позже",
  "Rotating": "Обновляем…",
  "Rotate confirm": "Точно обновить? Нажмите ещё раз",
  "Rotate link": "Обновить ссылку",
  "Rotate wait": "Доступно через {{count}} мин",
  "Rotate warn short": "Старый адрес перестанет работать",
  "New sub address": "Новый адрес подписки:",
  "Rotate note": "Профиль придётся добавить в приложение заново. Кто уже подключился по старой ссылке, останется до конца срока подписки.",
  "Home hero title": "Подключите VPN за минуту",
  "Home hero desc": "Выберите тариф, конфиг откроется сразу после оплаты. Без регистрации, без приложений.",
  "Open plans": "Открыть тарифы",
  "Feature fast": "Быстро",
  "Feature fast hint": "VLESS Reality, минимум пингов",
  "Feature private": "Приватно",
  "Feature private hint": "Без логов трафика",
  "Feature simple": "Просто",
  "Feature simple hint": "QR и готово",
  "Have promo": "Уже есть промокод?",
  "Have promo desc": "Введите его на следующем шаге при выборе тарифа, скидка применится автоматически.",
  "Traffic invoice open": "Счёт открыт. После оплаты ГБ зачислятся автоматически.",
  "Invoice failed detail": "Не удалось создать счёт: {{error}}",
  "Buy traffic": "Купить трафик",
  "Buy traffic desc": "Дополнительные ГБ к текущей подписке. Платите у провайдера, ГБ зачислятся автоматически.",
  "Buy for": "Купить за {{price}}",
  "Pick a pack": "Выберите пакет",
  "Confirm purchase": "Подтвердите покупку",
  "Charge from balance": "Списать {{amount}} с баланса?",
  "Pay plan from balance": "Оплатить «{{plan}}» с баланса? Спишется {{amount}}.",
  "Renew balance confirm": "Продлить «{{plan}}» на {{days}}? С баланса спишется {{amount}}.",
  "Payment confirm title": "Подтверждение оплаты",
  "Buy for price": "Купить за {{price}}₽",
  "Plans hint": "Выберите срок, потом тариф. Чем длиннее, тем выгоднее в день.",
  "Plans bypass title": "Работает там, где блокируют",
  "Plans bypass desc": "Пробивает белые списки и глушилки мобильного интернета",
  "Plans step period": "1. Срок подписки",
  "Plans step plan": "2. Тариф",
  "Popular": "Популярный",
  "Unlimited everywhere": "Безлимит на всех локациях",
  "GB for bypass": "{{gb}} ГБ на обход белых списков",
  "Per day": "~{{price}} ₽/день",
  "Period short day": "дн.",
  "Period short month": "мес.",
  "Period short months2": "2 мес.",
  "Period short months3": "3 мес.",
  "Period short months6": "6 мес.",
  "Period short year": "год",
  "Trial activated": "Пробный период активирован!",
  "Trial already used": "Вы уже использовали пробный период.",
  "Trial unavailable": "Пробный период сейчас недоступен.",
  "Trial plan unavailable": "Пробный тариф временно недоступен.",
  "Trial channels title": "Пробник для подписчиков канала",
  "Trial channels note": "Подпишитесь на канал, потом активируйте пробный период.",
  "Trial channel required": "Сначала подпишитесь на канал, потом активируйте пробный период.",
  "Stars shop title": "Нет звёзд?",
  "Stars shop step buy": "Нужно звёзд: {{count}}. Купите их за рубли в нашем магазине.",
  "Stars shop step pay": "Вернитесь в бот оплаты и нажмите «Оплатить».",
  "Buy stars": "Купить звёзды",
  "Trial failed": "Не удалось активировать триал. Попробуйте позже.",
  "Try free": "Попробовать бесплатно",
  "Try free days": "Попробовать бесплатно на {{days}}",
  "Trial note": "Пробный период без оплаты. Потом можно перейти на платный тариф.",
  "Trial bypass note": "В пробном периоде нет серверов обхода белых списков и глушилок мобильного интернета, они работают только на платных тарифах.",
  "Whitelist test done": "Тест белых списков пройден",
  "Whitelist test buy": "Тест белых списков за {{price}} ₽",
  "Whitelist used note": "Этот тариф покупается один раз. Дальше берите обычный: на нём серверы обхода без ограничения по сроку.",
  "Plans locations note": "{{count}} включены в любой тариф",
  "More": "подробнее",
  "Voucher activated": "Подписка «{{plan}}» активирована",
  "Voucher free": "Тариф «{{plan}}» для вас бесплатно.",
  "Voucher title": "Подарочный код",
  "Activate": "Активировать",
  "Promo exhausted": "Промокод закончился, счёт без скидки.",
  "Promo unavailable": "Скидку по коду сейчас применить нельзя, поэтому цена полная. Напишите в поддержку бота.",
  "Get for free": "Получить бесплатно",
  "Free price": "Бесплатно",
  "Get for free confirm": "Оформить подписку бесплатно?",
  "Provider unavailable": "Подписку пока не удалось выдать. Деньги на балансе целы, попробуйте через несколько минут",
  "Balance pay failed": "Не удалось оплатить с баланса",
  "Pay from balance": "Оплатить с баланса · {{price}}\u00a0₽",
  "Biometry ask": "Подтверждать покупки отпечатком или Face ID? Это можно изменить в профиле.",
  "Biometry title": "Подтверждение покупок",
  "Yes": "Да",
  "Pay amount": "Оплатить {{amount}}\u00a0₽?",
  "Plan gone": "Тариф недоступен",
  "Plan gone desc": "Похоже, этот тариф сняли с продажи. Актуальные есть в списке.",
  "To plans": "К тарифам",
  "From balance": "С баланса",
  "Not enough topup": "Не хватает {{amount}} ₽, пополнить",
  "Not enough": "Не хватает {{amount}} ₽",
  "Top up arrow": "Пополнить →",
  "Whitelist scarce note": "Серверы с белыми списками в дефиците: РКН блокирует их всё чаще. Чтобы их хватило всем, тест стоит недорого, живёт пару дней и покупается один раз. Если всё работает, берите обычный тариф.",
  "Whitelist test sub": "{{days}} · {{devices}}",
  "Whitelist test sub gb": "{{days}} · {{devices}} · {{gb}} ГБ на обход",
  "Gift status pending": "Ждёт оплаты",
  "Gift status ready": "Готов к отправке",
  "Gift status claimed": "Активирован",
  "Gift status expired": "Истёк",
  "Gift title": "Подарить подписку",
  "Gift desc": "Оплатите тариф и отправьте другу ссылку. Он откроет её и получит подписку. Своя подписка для этого не нужна.",
  "Gift create failed": "Не удалось создать подарок: {{error}}",
  "Gift paid": "Подарок оплачен с баланса, ссылка готова",
  "Gift confirm buy": "Подтвердите покупку подарка",
  "Pick a plan": "Выберите тариф",
  "Pay from balance section": "Оплата с баланса",
  "Gift from balance": "Подарить с баланса · {{price}} ₽",
  "Create invoice": "Создать счёт",
  "Gift paid note": "Подарок оплачен. Отправьте ссылку тому, кому дарите.",
  "Gift invoice note": "Счёт открыт. После оплаты ссылка станет рабочей, отправьте её другу.",
  "Gifts empty": "Подарков пока нет",
  "Gifts empty desc": "Купленные подарки появятся здесь вместе со ссылками.",
  "My gifts": "Мои подарки",
  "Gift created at": "Создан {{date}}",
  "Gift paid at": "оплачен {{date}}",
  "Gift claimed by": "Активировал {{who}} · {{date}}",
  "Gift recipient": "получатель",
  "Gift link copied": "Ссылка-подарок скопирована",
  "Copy failed": "Не удалось скопировать",
  "Gift share text": "Дарю вам VPN-подписку",
  "Share in Telegram": "Поделиться в Telegram",
  "Payment check failed": "Не удалось проверить платёж",
  "Payment check failed desc": "Бэкенд недоступен. Если вы уже оплатили, деньги дойдут и подписка активируется автоматически.",
  "To home": "На главную",
  "Payment pending": "Платёж ещё не подтвердился",
  "Payment pending desc": "Если вы уже оплатили, деньги дойдут в течение нескольких минут, и подписка активируется автоматически. Это окно можно закрыть.",
  "Paid sub coming": "Оплата прошла, подписка на подходе",
  "Paid sub coming desc": "Деньги зачислены на ваш баланс и никуда не денутся. Выдать подписку прямо сейчас не получилось, мы повторяем автоматически, обычно это занимает несколько минут. Повторно платить не нужно, мы пришлём уведомление.",
  "Check again now": "Проверить снова",
  "Payment failed": "Оплата не прошла",
  "Invoice expired": "Счёт истёк. Попробуйте ещё раз.",
  "Invoice cancelled": "Счёт отменён. Попробуйте ещё раз.",
  "Step crediting balance": "Зачисляем на баланс",
  "Step crediting traffic": "Зачисляем трафик",
  "Step renewing": "Продлеваем подписку",
  "Step preparing gift": "Готовим подарок",
  "Renew invoice failed": "Не удалось создать счёт на продление",
  "Renewed from balance": "Подписка продлена с баланса",
  "Renew balance failed": "Не удалось продлить с баланса",
  "Go paid caps": "Выбрать тариф",
  "Pay from balance caps": "Оплатить с баланса · {{price}} ₽",
  "Renew unavailable": "Продление недоступно",
  "Renew whitelist note": "Он покупается один раз и не продлевается: серверы обхода в дефиците. Возьмите обычный тариф, там они без ограничения по сроку.",
  "Renew whitelist name": "тест белых списков",
  "Renew trial note": "его нельзя продлить. Чтобы пользоваться дальше, выберите платный тариф.",
  "Renew trial name": "пробный период",
  "This is": "Это",
  "Go to paid plan": "Выбрать тариф",
  "Renew frozen note": "Подписка заморожена. Сначала разморозьте её на главной, после этого можно продлить.",
  "Renew period": "Срок продления",
  "Custom period": "Свой срок",
  "Plan period days_one": "{{count}} день (тариф)",
  "Plan period days_few": "{{count}} дня (тариф)",
  "Plan period days_many": "{{count}} дней (тариф)",
  "Plan period days_other": "{{count}} дней (тариф)",
  "N days short_one": "{{count}} день",
  "N days short_few": "{{count}} дня",
  "N days short_many": "{{count}} дней",
  "N days short_other": "{{count}} дней",
  "For N days_one": "за {{count}} день",
  "For N days_few": "за {{count}} дня",
  "For N days_many": "за {{count}} дней",
  "For N days_other": "за {{count}} дней",
  "Days range hint": "от {{min}} до {{max}} дней",
  "Renew promo applied": "Промокод {{code}} применён",
  "Active until date": "Будет активна до {{date}}",
  "Auto renew period": "Продлевать на",
  "Auto renew period plan": "период тарифа",
  "Auto renew period custom": "{{count}} дн.",
  "Renew title": "Продление подписки",
  "Renew adds to end": "Новый срок добавится к текущей дате окончания.",
  "Opening client": "Открываем {{client}}. Если он не установлен, скопируйте ссылку ниже и импортируйте вручную.",
  "Link rotated": "Ссылка обновлена. Старая больше не работает.",
  "Rotate once per hour": "Обновлять ссылку можно раз в час. Попробуйте позже.",
  "Rotate failed generic": "Не удалось обновить ссылку. Попробуйте позже.",
  "Open connect page": "Открыть страницу подключения",
  "Rotate note long": "Старая ссылка перестанет работать, и по ней больше никто не подключится. Профиль придётся заново добавить на своих устройствах. Те, кто уже подключился по старой ссылке, останутся до конца срока подписки.",
  "Just now": "только что",
  "Min ago": "{{count}} мин назад",
  "Hours ago": "{{count}} ч назад",
  "Yesterday": "вчера",
  "Device disconnected": "Устройство отключено. Вернуть можно ниже",
  "Delete failed": "Не удалось удалить",
  "Device reconnecting": "Устройство снова подключается",
  "Device restore failed": "Не получилось вернуть устройство",
  "Online": "в сети",
  "Was online": "был в сети {{when}}",
  "Activity unknown": "активность неизвестна",
  "Connected since": "подключено {{when}}",
  "Disconnected devices": "Отключённые",
  "Disconnected desc": "Этим устройствам мы не отдаём настройки серверов. Верните, чтобы снова подключались.",
  "Disconnected at": "отключено {{when}}",
  "Restore": "Вернуть",
  "Disconnect device?": "Отключить устройство?",
  "Disconnect device desc": "{{name}} освободит слот и перестанет получать настройки серверов: в приложении появится «Устройство отключено». Вернуть его можно тут же, в разделе «Отключённые».",
  "Disconnect": "Отключить",
  "Loyalty": "Лояльность",
  "No status": "Без статуса",
  "Renewals count": "Продлений: {{count}}",
  "Loyalty next": "до «{{title}}» осталось {{count}} ({{bonus}}% бонус)",
  "Loyalty level bonus": "+{{bonus}}% к продлению",
  "Loyalty level renewals_one": "{{count}} продление",
  "Loyalty level renewals_few": "{{count}} продления",
  "Loyalty level renewals_many": "{{count}} продлений",
  "Loyalty level renewals_other": "{{count}} продлений",
  "Loyalty level left": "осталось {{count}}",
  "Links": "Ссылки",
  "Top up balance": "Пополнить баланс",
  "Setting save failed": "Не удалось сохранить настройку",
  "Biometry row": "Подтверждать отпечатком",
  "Biometry row desc": "Face ID или отпечаток перед оплатой",
  "Backend down": "Сервер недоступен, попробуйте позже",
  "Backend down desc": "Данные временно не загружаются. Повторим автоматически.",
  "Report it": "Сообщить",
  "Subscribe to continue": "Подпишитесь, чтобы продолжить",
  "Subscribe channels one": "Чтобы пользоваться ботом, подпишитесь на канал ниже.",
  "Subscribe channels many": "Чтобы пользоваться ботом, подпишитесь на каналы ниже.",
  "Channel": "Канал",
  "I subscribed": "Я подписался",
  "GB pack": "+{{gb}} ГБ",
  "GB pack unlimited": "+∞",
  "Plan word": "подписка",
  "No devices yet": "Устройств пока нет",
  "Renew via": "Продлить за {{price}} ₽ через {{provider}}",
  "Renew via auto": "Продлить за {{price}} ₽ через {{provider}} · автопродление",
  "Fee badge": "сбор {{percent}} %",
  "Expired title": "Подписка закончилась",
  "Expired on": "Истекла {{date}}",
  "Expired renew hint": "Продлите её, и VPN заработает по той же ссылке: настраивать устройства заново не нужно.",
  "Expired gone hint": "Этот тариф больше не продаётся. Выберите новый, и подписка начнётся сразу.",
  "Expired section": "Закончились",
  "Topup": "Пополнить на {{amount}} ₽",
  "Buy another plan": "Купить ещё подписку",
  "Buy another plan hint": "Отдельная подписка со своим сроком и ссылкой",
  "Plans existing sub note": "У вас уже есть подписка. Новая покупка создаст отдельную подписку и не продлит текущую.",
  "Plans renew current": "Продлить текущую",
  "Web access": "Доступ с сайта",
  "Sign in on the website with your email, even if Telegram is unavailable": "Заходите в кабинет на сайте по почте, даже если Telegram недоступен",
  "Not set up": "Не настроен",
  "Email": "Почта",
  "Password": "Пароль",
  "At least 8 characters": "Не короче 8 символов",
  "At least 8 characters. If this email already has a website account, enter its password": "Не короче 8 символов. Если на эту почту уже есть аккаунт на сайте, введите пароль от него",
  "Wrong password for the website account with this email": "Неверный пароль от аккаунта на сайте с этой почтой",
  "Send code": "Отправить код",
  "Code from the email": "Код из письма",
  "We sent a code to {{email}}": "Отправили код на {{email}}",
  "Email linked, you can sign in on the website": "Почта привязана, теперь можно войти на сайте",
  "Accounts merged, subscriptions from the website are here now": "Аккаунты объединены, подписки с сайта теперь здесь",
  "This email already has a website account. After confirming, its subscriptions and balance will move here": "На эту почту уже есть аккаунт на сайте. После подтверждения его подписки и баланс перейдут сюда",
  "Could not link email": "Не удалось привязать почту",
  "Section term": "На срок",
  "Section lifetime": "Навсегда",
  "Lifetime hint": "Платите один раз, и подписка работает без срока окончания.",
  "Lifetime title": "Подписка «Навсегда»",
  "Lifetime once note": "Оплата один раз, продлевать не нужно",
  "Lifetime no expiry": "Без срока окончания",
  "Lifetime devices_one": "До {{count}} устройства",
  "Lifetime devices_few": "До {{count}} устройств",
  "Lifetime devices_many": "До {{count}} устройств",
  "Lifetime devices_other": "До {{count}} устройств",
  "Lifetime own network": "Своя сеть серверов, отдельная от подписок на срок",
  "Lifetime servers unlimited": "Стабильные серверы без лимита трафика",
  "Lifetime bypass traffic": "Свежие обходы белых списков: {{gb}} ГБ, не сгорают",
  "Lifetime addons note": "Не хватит трафика или устройств, докупите в карточке подписки",
  "Lifetime get": "Оформить",
  "Lifetime load failed": "Не удалось загрузить тариф «Навсегда».",
  "Lifetime unavailable": "Раздел «Навсегда» сейчас недоступен.",
  "Show term plans": "Показать тарифы на срок",
  "Trial choose note": "Пробник один на человека. Выберите тот, которым будете пользоваться дальше.",
  "Trial term option": "На срок · {{days}}",
  "Trial term option note": "Обычная подписка, потом тариф на месяц, полгода или год.",
  "Trial lifetime option": "Навсегда · {{days}}",
  "Trial lifetime option note": "Эксклюзивный тариф без срока окончания. Своя сеть серверов, отдельная от подписок на срок: стабильные серверы и свежие обходы белых списков. В пробнике 10 ГБ на обычных серверах и 100 МБ на обходе.",
  "Order plan lifetime": "До {{devices}} устройств, навсегда",
  "Lifetime forever": "навсегда",
  "Term": "Срок",
  "Traffic note lifetime": "Трафик обхода не сгорает. На остальных серверах трафик без лимита.",
  "Choose plan": "Выбрать тариф",
  "Add devices": "+15 устройств",
  "Add devices title": "Ещё 15 устройств",
  "Add devices desc": "Сейчас можно подключить до {{now}} устройств. После покупки станет {{after}}.",
  "Lifetime traffic desc": "Пакет добавится к остатку обхода белых списков и не сгорает, пока вы его не потратите. На остальных серверах трафик и так без лимита.",
  "Addons unavailable": "Докупки к этой подписке сейчас недоступны.",
  "Addons load failed": "Не удалось загрузить цены.",
  "Addon devices pack_one": "+{{count}} устройство",
  "Addon devices pack_few": "+{{count}} устройства",
  "Addon devices pack_many": "+{{count}} устройств",
  "Addon devices pack_other": "+{{count}} устройств",
  "Addon done traffic": "Готово: +{{gb}} ГБ для обхода белых списков",
  "Addon done devices_one": "Готово: теперь до {{count}} устройства",
  "Addon done devices_few": "Готово: теперь до {{count}} устройств",
  "Addon done devices_many": "Готово: теперь до {{count}} устройств",
  "Addon done devices_other": "Готово: теперь до {{count}} устройств",
  "Addon no balance": "На балансе не хватает денег. Оплатите счётом или пополните баланс.",
  "Pay from balance price": "С баланса · {{price}}",
  "Lifetime no renew": "Подписка «Навсегда» бессрочная, продлевать её не нужно.",
  "Back to subscription": "К подписке",
  "Addon applied": "Готово, докупка применена",
  "Step applying addon": "Добавляем к подписке",
  "Withdraw title": "Вывод заработка",
  "Withdraw manual note": "Деньги переводит владелец сервиса. Напишем в чат, когда перевод уйдёт.",
  "Withdraw load failed": "Не удалось загрузить данные о выводе.",
  "Withdraw unavailable title": "Вывод сейчас недоступен",
  "Withdraw unavailable desc": "Владелец сервиса выключил вывод. Бонусы по-прежнему приходят на баланс, ими можно оплатить подписку.",
  "Withdraw history": "История заявок",
  "Withdraw earned": "Заработано по рефералке",
  "Withdraw available": "Можно вывести",
  "Withdraw available short": "Можно вывести {{amount}}",
  "Withdraw available note": "Сюда не входит то, что уже выведено или ждёт в заявке. Оплата с баланса сначала списывает заработанное по рефералке.",
  "Withdraw request label": "Заявка на вывод",
  "Withdraw waiting transfer": "Ждёт перевода от владельца сервиса. Пока заявка открыта, сумма отложена с баланса.",
  "Withdraw processing note": "Владелец сервиса уже переводит деньги. Отменить заявку сейчас нельзя.",
  "Withdraw where": "Куда",
  "Withdraw details": "Реквизиты",
  "Withdraw created": "Создана",
  "Withdraw cancel": "Отменить заявку",
  "Withdraw cancelling": "Отменяем…",
  "Withdraw cancel title": "Отменить заявку?",
  "Withdraw cancel desc": "{{amount}} вернутся на баланс. Новую заявку можно отправить сразу.",
  "Withdraw keep": "Оставить",
  "Withdraw cancelled toast": "Заявка отменена, {{amount}} вернулись на баланс",
  "Withdraw already decided": "По этой заявке уже есть решение, статус обновлён.",
  "Withdraw cancel failed": "Не удалось отменить заявку. Попробуйте ещё раз.",
  "Withdraw processing no cancel": "Владелец сервиса уже переводит деньги, отменить заявку нельзя.",
  "Withdraw amount whole": "Введите сумму целым числом.",
  "Withdraw amount min": "Минимальная сумма вывода {{amount}}.",
  "Withdraw amount max": "Можно вывести не больше {{amount}}.",
  "Withdraw min hint": "Минимум {{amount}}",
  "Withdraw all chip": "Всё: {{amount}}",
  "Withdraw not enough": "До вывода не хватает {{amount}}",
  "Withdraw not enough hint": "Вывод от {{amount}}. Бонус приходит, когда приглашённый друг оплачивает подписку.",
  "Withdraw from min": "Вывод от {{amount}}",
  "Withdraw no methods": "Владелец сервиса ещё не выбрал, куда переводить деньги. Загляните позже.",
  "Withdraw method card": "Карта",
  "Withdraw method sbp": "СБП",
  "Withdraw method usdt_trc20": "USDT TRC20",
  "Withdraw method gone": "Этот способ больше недоступен. Выберите другой.",
  "Withdraw card label": "Номер карты",
  "Withdraw card hint": "От 16 до 19 цифр, как на карте.",
  "Withdraw card short": "В номере карты от 16 до 19 цифр.",
  "Withdraw card invalid": "Номер карты не проходит проверку. Сверьте цифры с картой.",
  "Withdraw phone label": "Телефон",
  "Withdraw phone hint": "Номер, на который вам приходят переводы по СБП.",
  "Withdraw phone invalid": "Нужен российский номер: +7 и 10 цифр.",
  "Withdraw bank label": "Банк",
  "Withdraw bank hint": "Банк, в который вам приходят переводы по СБП.",
  "Withdraw bank placeholder": "Например, Т-Банк",
  "Withdraw bank invalid": "Название банка: от 2 до {{max}} символов.",
  "Withdraw trc20 label": "Адрес USDT (TRC20)",
  "Withdraw trc20 hint": "Сеть TRON, адрес начинается с T. Перевод в другой сети не дойдёт.",
  "Withdraw trc20 invalid": "Адрес TRC20 начинается с T и состоит из 34 символов.",
  "Withdraw submit": "Вывести",
  "Withdraw submit amount": "Вывести {{amount}}",
  "Withdraw confirm title": "Проверьте заявку",
  "Withdraw confirm message": "Сумма: {{amount}}\n{{method}}: {{destination}}\n\nВладелец сервиса переведёт деньги на эти реквизиты. Всё верно?",
  "Withdraw confirm ok": "Отправить",
  "Withdraw sent toast": "Заявка на {{amount}} отправлена. Напишем в чат, когда деньги переведут.",
  "Withdraw paid now toast": "Готово: {{amount}} отправлены. Чек и подробности в чате и в истории ниже.",
  "Withdraw open exists": "У вас уже есть открытая заявка. Дождитесь ответа или отмените её.",
  "Withdraw send failed": "Не удалось отправить заявку. Попробуйте ещё раз чуть позже.",
  "Withdraw too frequent": "Слишком много заявок за последний час. Попробуйте позже.",
  "Withdraw open short": "Заявка на {{amount}} ждёт перевода",
  "Withdraw processing short": "Заявка на {{amount}}: деньги уже переводят",
  "Withdraw status pending": "Ждёт",
  "Withdraw status processing": "Переводят",
  "Withdraw status paid": "Выплачено",
  "Withdraw status rejected": "Отклонено",
  "Withdraw status cancelled": "Отменено",
  "Withdraw reject reason": "Причина: {{reason}}",
  "Withdraw method ton": "GRAM (TON)",
  "Withdraw method cryptobot": "CryptoBot (USDT)",
  "Withdraw to telegram": "ваш Telegram",
  "Withdraw platform note": "Выплату проводит сервис автоматически. Напишем в чат, когда деньги уйдут.",
  "Withdraw ton label": "Адрес TON-кошелька",
  "Withdraw ton hint": "Кошелёк в сети TON, куда отправить GRAM. Адрес начинается с UQ или EQ.",
  "Withdraw ton invalid": "Не похоже на адрес TON-кошелька: он начинается с UQ или EQ и состоит из 48 символов.",
  "Withdraw memo label": "Комментарий (memo)",
  "Withdraw memo hint": "Нужен, если кошелёк на бирже: без него биржа не зачислит перевод. Для обычного кошелька оставьте пустым.",
  "Withdraw memo placeholder": "Необязательно",
  "Withdraw memo invalid": "Комментарий: до {{max}} символов, одной строкой.",
  "Withdraw cryptobot note": "Чек @CryptoBot в USDT придёт в этот чат. Забрать его сможете только вы, со своего Telegram.",
  "Withdraw net label": "Придёт на руки",
  "Withdraw net line": "При автоматической выплате придёт {{net}}",
  "Withdraw fee line": "Комиссия сети и сервиса {{fee}} списывается из суммы.",
  "Withdraw quote failed": "Не удалось посчитать комиссию. Попробуйте чуть позже.",
  "Withdraw confirm net": "При автоматической выплате придёт {{net}}.",
  "Withdraw open check": "Забрать чек",
  "Withdraw open tx": "Перевод в сети TON",
  "Intent withdraw request": "Заявка на вывод",
  "Intent withdraw return": "Возврат заявки на вывод",
  "Intent account merge": "Перенос баланса при объединении аккаунтов",
  "Intent account merge bonus": "Перенос бонусов при объединении аккаунтов",
  "FAQ questions": "Вопросы и ответы",
  "Countries in subscription": "Страны в подписке",
  "Countries shown of": "{{shown}} из {{total}}",
  "Countries explain": "Отметьте страны, которые нужны в VPN-приложении. Новые страны появятся сами.",
  "Countries locked": "Выбор стран выключил владелец сервиса.",
  "Countries show all": "Вернуть все страны",
  "Countries servers_one": "{{count}} сервер",
  "Countries servers_few": "{{count}} сервера",
  "Countries servers_many": "{{count}} серверов",
  "Countries servers_other": "{{count}} сервера",
  "Countries limited": "обход белых списков: {{count}}",
  "Countries saved": "Сохранено",
  "Countries saved hint": "Обновите подписку в VPN-приложении, чтобы список стран изменился.",
  "Countries save failed": "Не удалось сохранить, попробуйте ещё раз.",
  "Countries load failed": "Не удалось загрузить список стран.",
  "Countries keep one": "Оставьте хотя бы одну страну.",
  "All countries shown": "Все страны",
  "Save": "Сохранить",
  "Saving": "Сохраняю…",
  "Countries auto note": "«🌍 Авто-выбор» в Happ подбирает сервер из всех стран. Чтобы ходить только через выбранные, выберите сервер в приложении вручную.",
  "Add to app": "Добавить в приложение",
  "Add to app hint": "Happ, v2RayTun и похожие",
  "All operations": "Все операции",
  "All plans": "Все тарифы",
  "Balance": "Баланс",
  "Bypass": "Обход",
  "Countries word_one": "страна",
  "Countries word_few": "страны",
  "Countries word_many": "стран",
  "Countries word_other": "стран",
  "Days word_one": "день",
  "Days word_few": "дня",
  "Days word_many": "дней",
  "Days word_other": "дней",
  "Devices word_one": "{{count}} устройство",
  "Devices word_few": "{{count}} устройства",
  "Devices word_many": "{{count}} устройств",
  "Devices word_other": "{{count}} устройств",
  "Friends": "Друзья",
  "From price": "от {{price}}",
  "From their payments": "с их оплат вам",
  "GB": "ГБ",
  "Giveaways count_one": "{{count}} розыгрыш",
  "Giveaways count_few": "{{count}} розыгрыша",
  "Giveaways count_many": "{{count}} розыгрышей",
  "Giveaways count_other": "{{count}} розыгрышей",
  "Hello": "Привет",
  "Hello name": "Привет, {{name}}",
  "History": "История",
  "How step 1": "Возьмите пробный период или тариф",
  "How step 2": "Нажмите «Добавить в приложение»",
  "How step 3": "Включите VPN в Happ",
  "How to connect": "Как подключить",
  "Invite friends": "Приглашайте друзей",
  "Invite friends hint": "{{l1}}% с каждой оплаты друга на ваш баланс.",
  "Invite friends hint l2": "И {{l2}}% с оплат тех, кого пригласят они.",
  "Invited word_one": "друг",
  "Invited word_few": "друга",
  "Invited word_many": "друзей",
  "Invited word_other": "друзей",
  "Locations": "Локации",
  "No limit": "без лимита",
  "Of total gb": "из {{total}}",
  "Open subscription": "Открыть подписку",
  "Paused": "На паузе",
  "Per month": "в месяц",
  "Renews itself": "Продлится сама",
  "Start trial": "Начать пробный период",
  "Subscription tab": "Подписка",
  "Trial days free_one": "{{count}} день бесплатно",
  "Trial days free_few": "{{count}} дня бесплатно",
  "Trial days free_many": "{{count}} дней бесплатно",
  "Trial days free_other": "{{count}} дней бесплатно",
  "Try VPN free": "Попробуйте VPN без оплаты",
  "Up to n_one": "до {{count}}",
  "Up to n_few": "до {{count}}",
  "Up to n_many": "до {{count}}",
  "Up to n_other": "до {{count}}",
  "Wallet": "Кошелёк",
  "Withdraw": "Вывести",
  "Works": "Работает",
  "of n_one": "из {{count}}",
  "of n_few": "из {{count}}",
  "of n_many": "из {{count}}",
  "of n_other": "из {{count}}",
  "Buy GB hint": "Пакеты трафика обхода",
  "Days left n_one": "осталось {{count}} день",
  "Days left n_few": "осталось {{count}} дня",
  "Days left n_many": "осталось {{count}} дней",
  "Days left n_other": "осталось {{count}} дней",
  "Link for the app": "Ссылка для приложения",
  "Manage devices": "Все устройства",
  "More devices": "Больше устройств",
  "More devices hint": "Перейти на тариф побольше",
  "Pause hint": "Дни не тратятся, пока подписка на паузе",
  "Pause subscription": "Поставить на паузу",
  "No subscription yet": "Подписки пока нет",
  "No subscription yet hint": "Выберите тариф или возьмите пробный период на главной.",
  "Devices of": "Устройства · {{used}} из {{total}}",
  "Less than a day left": "меньше дня",
  "Connections log": "Журнал подключений",
  "Connect short": "Подключить",
  "Provider heleket": "Криптовалюта",
  "Check connection and retry": "Проверьте связь и нажмите, чтобы повторить",
  "Send to friend": "Отправить другу",
  "Wallet load failed": "Не удалось загрузить кошелёк",
  "Up to devices_one": "до {{count}} устройства",
  "Up to devices_few": "до {{count}} устройств",
  "Up to devices_many": "до {{count}} устройств",
  "Up to devices_other": "до {{count}} устройств",
  "No end date": "Без срока",
  "Plan kicker": "Тариф",
  "Link short": "Ссылка",
  "Buy more short": "Докупить",
  "Summary": "Сводка",
  "Devices unit_one": "устройство",
  "Devices unit_few": "устройства",
  "Devices unit_many": "устройств",
  "Devices unit_other": "устройств",
  "At the same time": "одновременно",
  "Connected now": "подключено сейчас",
  "Plans title": "Тарифы",
  "Does not burn": "не сгорает",
  "From each payment of friend": "с каждой их оплаты",
  "Earned short": "заработано",
  "To withdraw short": "к выводу",
  "Renew automatically": "Продлевать автоматически",
  "Recurrent hint on": "{{amount}} {{period}}. Отключить можно в любой момент на экране подписки.",
  "Recurrent hint off": "Подписка не продлится сама: продлите её вручную, когда закончится.",
  "Recurrent terms": "Условия автосписания",
  "Recurrent period MONTH": "раз в месяц",
  "Recurrent period QUARTER": "раз в 3 месяца",
  "Recurrent period YEAR": "раз в год",
  "Auto-payment": "Автосписание",
  "Auto-payment hint": "{{amount}} {{period}}, следующее {{date}}",
  "Auto-payment hint nodate": "{{amount}} {{period}}",
  "Auto-payment failing": "Последняя попытка не прошла, платёжный сервис попробует ещё",
  "Auto-payment cancel confirm": "Деньги больше не будут списываться. Подписка работает до {{date}}, потом её можно продлить вручную.",
  "Auto-payment cancel title": "Отключить автосписание?",
  "Turn off": "Отключить",
  "Auto-payment off toast": "Автосписание отключено",
  "Auto-payment cancel failed": "Платёжный сервис не ответил. Попробуйте через минуту."
};

export default ru;
